export const generatePopupDrawerClass = (componentType: string) => {
    if (componentType === 'popups') return "popup-component__drawer";
    return "";
}